import { createFileRoute } from "@tanstack/react-router";
import { ProfileScreen } from "../components/settings/profile-screen.tsx";
import { SettingsLoading } from "../components/settings/shell.tsx";
import { useSettingsFranchise } from "../components/settings/use-settings-franchise.ts";

export const Route = createFileRoute("/installningar/profil")({ component: Screen });

function Screen() {
  const franchise = useSettingsFranchise();
  if (franchise === null) return <SettingsLoading />;
  return <ProfileScreen franchiseId={franchise.id} />;
}
